import styles from './CartTyre.module.scss'
import { CartRowModel, TyreSizeModel } from '@/types/api'
import React from 'react'
import Button from '@/components/buttons/Button/Button'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

type Props = {
  item: CartRowModel
}

const CartTyre = ({
  item
}: Props) => {
  const { t } = useTranslation('cart')
  const router = useRouter()
  const onClick = (size: TyreSizeModel) => {
    router.push(`/tyres?width=${size.width}&aspectRatio=${size.aspectRatio}&diameter=${size.diameter}`)
  }

  if (!item.tyreSizes || item.tyreSizes.length === 0)
    return null

  return (
    <div className={styles.component}>
      <label>{t('searchTyres')}</label>
      {item.tyreSizes?.map((size, index) => (
        <div key={index} className={styles.row}>
          <Button
            label={`${size.width}/${size.aspectRatio}-${size.diameter}`}
            onClick={() => onClick(size)}
          />
        </div>
      ))}
    </div>
  )
}

export default CartTyre